import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { BackendResponse } from '@qtek/shared/models';

@Injectable({
  providedIn: 'root',
})
export class IntegrationsService {
  private http = inject(HttpClient);

  getIntercomToken(): Observable<BackendResponse<{ intercomToken: string }>> {
    return this.http.get<BackendResponse<{ intercomToken: string }>>(
      '/api/v2/intercom/token',
      { withCredentials: true }
    );
  }
}
